import Animations from './modules/Animations'
import Menu from './modules/Menu'
import Sliders from './modules/Sliders'
import Swup from 'swup'

// Debug helper
const debug = true

if (!debug) {
  console.log = function () {}
}

export default class Main {
  constructor() {
    this.init()
  }

  init() {
    const swup = new Swup({
      animationSelector: '[class*="swup-transition-"]',
    })

    // run once when page loads
    window.addEventListener('load', () => {
      this.initialize()
    })

    // run after every additional navigation by swup
    swup.on('contentReplaced', this.initialize)
    swup.on('willReplaceContent', this.destory)
  }

  initialize() {
    Animations.init()
    Menu.init()
    Sliders.init()
  }

  destory() {
    Animations.destroyScrolls()
  }
}

const main = new Main()
